/**
 * Host-side ctx factory — Phase L4b.
 *
 * The Script Widget runs inside `scriptSandbox.js` (sandboxed iframe). The
 * sandbox builds its own ctx wrapper on every invoke; this module is just the
 * data we ship across to the sandbox per call. Keep it JSON-serialisable.
 *
 * Versioned: the sandbox accepts a `ctx_version` field in the invoke message.
 * v1 is the only version today. Future SDK majors add to `SDK_REGISTRY` and
 * keep v1 alive for two majors per LAYOUTS_PLAN.md §0.10.
 */

const SDK_VERSION = '1.0';

/**
 * Produce the data half of `ctx` for an invocation. The sandbox layers on the
 * callable surface (`bus.publish`, `fetch`, `invokeAction`, `log`).
 *
 * @param {object} layoutCtx  Output of `useLayoutCtx()` from the host.
 * @param {object} sourceWidget  Tree node of the widget that triggered the wire (or the script widget itself).
 */
export function buildCtxForInvoke(layoutCtx, sourceWidget) {
  const safe = (v) => {
    if (v == null) return null;
    try { return JSON.parse(JSON.stringify(v)); } catch (_) { return null; }
  };
  return {
    sdk_version: SDK_VERSION,
    workspace_id: layoutCtx?.workspaceId || null,
    category: layoutCtx?.category || null,
    role: safe(layoutCtx?.role),
    current_user: safe(layoutCtx?.currentUser),
    case: safe(layoutCtx?.case),
    work_item: safe(layoutCtx?.workItem),
    draft: safe(layoutCtx?.draft),
    source_widget: sourceWidget ? { id: sourceWidget.id || null, type: sourceWidget.type || null } : null,
  };
}

export const SDK_REGISTRY = {
  '1.0': { buildCtxForInvoke },
};
